import LRow from './LRow.vue'
import LCol from './LCol.vue'

export default (Vue) => {
  Vue.component(LRow.name, LRow)
  Vue.component(LCol.name, LCol)
}
